<div *ngIf="orders$ | async as orders">
  <ng-container *ngIf="orders.length; else loading">
    <div class="md:flex md:flex-col md:items-center">
      <div class="px-5 pb-3 md:w-8/12">
        <div class="flex flex-col">
          <div
            class="flex flex-col lg:flex-row items-start gap-4"
            *ngFor="let order of orders"
          >
            <div class="border border-neutral-300 rounded-lg w-full">
              <app-order-status-atom-v2
                [order]="order"
                [shopName]="order.shop.name"
                [orderNumber]="order.number"
                [orderStatus]="order.status"
                [displayLocalizeButton]="displayLocalizeButton"
                [displayDetailsButton]="displayDetailsButton"
                [locationName]="onSiteLocationName$ | async"
                [textColor]="textColor"
                [secondaryTextColor]="secondaryTextColor"
              ></app-order-status-atom-v2>
            </div>
            <div
              *ngIf="displayShopContact && (order?.shop?.phone || order?.shop?.email)"
              class="border border-neutral-300 rounded-lg w-full lg:w-64 lg:flex-shrink-0 lg:ml-3"
            >
              <!-- TODO: Add proper [emailAddress] value from API response -->
              <app-actions-info-shop-atom
                [isFavourite]="false"
                [shopName]="order?.shop?.name"
                [phoneNumber]="order?.shop?.phone"
                [instagramURL]="order?.shop?.link_instagram"
                [facebookURL]="order?.shop?.link_facebook"
                [emailAddress]=""
                [twitterURL]="order?.shop?.link_twitter"
                [textColor]="textColor"
              ></app-actions-info-shop-atom>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #loading>
  <div class="bg-neutral-100 pt-5 px-5">
    <ng-container *ngFor="let i of [].constructor(2)">
      <div class="pb-5 flex flex-col items-center">
        <div
          class="bg-white rounded rounded-lg flex justify-between py-3 px-5 cursor-pointer w-full md:w-8/12 h-32"
        >
          <div class="w-full">
            <p class="animate-pulse h-6 bg-neutral-200 rounded w-32 mb-2"></p>
            <p class="animate-pulse h-4 bg-neutral-50 rounded w-44 mb-2"></p>
            <p class="animate-pulse h-4 bg-neutral-50 rounded w-56 mb-2"></p>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>
